import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/INVOICE_MODAL';

export const {action: show} = createAction(`${domain}/SHOW`, invoiceId => ({
    invoiceId,
}));

export const {action: showPreview} = createAction(
    `${domain}/SHOW_PREVIEW`,
    ({
        title,
        invoiceNumber,
        pdf,
        billPayerId,
        institutionId,
        invoiceId,
        invoicePeriod,
        invoiceBehaviors,
        useGraphQl,
    }) => ({
        title,
        invoiceNumber,
        pdf,
        billPayerId,
        institutionId,
        invoiceId,
        invoicePeriod,
        invoiceBehaviors,
        useGraphQl,
    }),
);

export const {
    action: fetchGraphQLPreview,
    success: fetchGraphQLPreviewSuccess,
    failed: fetchGraphQLPreviewFailed,
} = createAction(
    `${domain}/FETCH_GRAPH_QL_PREVIEW`,
    () => ({}),
    invoice => ({invoice}),
);

export const {
    action: showDetails,
    success: showDetailsSuccess,
    failed: showDetailsFailed,
} = createAction(
    `${domain}/SHOW_DETAILS`,
    (show, invoiceId, hasDetails) => ({
        show,
        invoiceId,
        hasDetails,
    }),
    children => ({children}),
);

export const {action: hide} = createAction(`${domain}/HIDE`);

export const {
    action: fetchSingle,
    success: fetchSingleSuccess,
    failed: fetchSingleFailed,
} = createAction(
    `${domain}/FETCH_SINGLE`,
    invoiceId => ({invoiceId}),
    invoice => ({invoice}),
);

export const {
    action: resend,
    success: resendSuccess,
    failed: resendFailed,
    aborted: resendAborted,
} = createAction(`${domain}/RESEND`, ({institutionId, billPayerId, invoiceId}) => ({
    institutionId,
    billPayerId,
    invoiceId,
}));

export const {
    action: cancel,
    success: cancelSuccess,
    failed: cancelFailed,
    aborted: cancelAborted,
} = createAction(
    `${domain}/CANCEL`,
    ({institutionId, billPayerId, invoiceId, notify, creditNoteDate}) => ({
        institutionId,
        billPayerId,
        invoiceId,
        notify,
        creditNoteDate,
    }),
    (institutionId, billPayerId, invoices) => ({institutionId, billPayerId, invoices}),
);

// for analytics purposes
export const {action: invoiceCancelClicked} = createAction(`${domain}/INVOICE_CANCEL_CLICKED`);

export const {action: showMoveModal} = createAction(
    `${domain}/MOVE`,
    (institutionId, billPayerId, invoiceId, invoiceBehaviors) => ({
        institutionId,
        billPayerId,
        invoiceId,
        invoiceBehaviors,
    }),
);
